import axios from "axios";
import { makeRequest } from "../utils/handleJWT";

const API_BASE_URL = "https://umlang.com/subtitles/api/v1";

// جستجوی زیرنویس با پارامترهای مختلف (POST)
export const searchSubtitles = async (searchParams, page = 1) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    // ساخت body درخواست
    const body = {
      limit: 50,
      page,
      nameOfMovie: searchParams.name,
    };

    // اضافه کردن پارامترهای اختیاری
    if (searchParams.language && searchParams.language !== "all") {
      body.subtitlesLanguage = searchParams.language;
    }

    if (searchParams.type === "series") {
      if (searchParams.season) body.season = parseInt(searchParams.season);
      if (searchParams.episode) body.episode = parseInt(searchParams.episode);
    }

    const response = await axios.post(
      `${API_BASE_URL}/subtitles/findSubtitles?limit=50&page=${page}`,
      body,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  });
};

// دریافت محتوای زیرنویس
export { fetchSubtitleContent } from "./subtitleApi";
